import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Button } from "Components/Common/Button/Button";
import ClassNames from "Helpers/Common";
import "Colors.css";

export default function Modal({
  open,
  setOpen,
  icon,
  btnText,
  content,
  heading,
  loading,
  children,
  isDisabled = false,
  showCancel = false,
}) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={setOpen}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
              <div>
                {icon && (
                  <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full">
                    {icon}
                  </div>
                )}
                <div className="mt-3 text-center sm:mt-5">
                  <Dialog.Title
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900"
                  >
                    {heading}
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      {content ? content : ""}
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-3 mb-3">{children}</div>

              <div className="mt-5 sm:mt-6 flex flex-col gap-4">
                {btnText && (
                  <Button
                    className={ClassNames(
                      `inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 0 text-sm font-medium sapphire  focus:outline-none sm:text-sm ${
                        isDisabled ? "sapphire" : "text-white"
                      }`
                    )}
                    btnText={btnText}
                    isDisabled={isDisabled}
                    isLoading={loading}
                    onClick={() => setOpen(btnText)}
                    variant={
                      btnText === "Deactivate" || btnText === "Delete"
                        ? "Delete"
                        : "Default"
                    }
                  />
                )}
                {showCancel && (
                  <Button
                    variant="transparent"
                    className="text-sm font-medium sapphire bg-transparent border border-gray-200 py-2 px-4 inline-flex rounded-md w-full"
                    btnText="Cancel"
                    isDisabled={false}
                    onClick={() => setOpen("Cancel")}
                  />
                )}
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
